import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { GraduationCap, ShoppingCart, LogIn, Award } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const brl = (c) => (c / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });

export const LoginCoursesTab = () => {
  const [courses, setCourses] = useState([]);
  useEffect(() => { axios.get(`${API}/public/courses`).then(({ data }) => setCourses(data)).catch(() => {}); }, []);

  return (
    <div className="w-full max-w-xs" data-testid="login-courses-tab">
      <p className="flex items-center gap-2 text-sm font-semibold text-white"><GraduationCap className="h-4 w-4 text-emerald-400" /> Cursos EAD de NR · 8h · certificado</p>
      <div className="mt-3 grid max-h-52 grid-cols-2 gap-2 overflow-y-auto pr-1" data-testid="login-courses-list">
        {courses.map((c) => (
          <Link key={c.id} to="/cursos" title={c.title} data-testid={`login-course-${c.nr}`}
            className="rounded-lg border border-white/10 bg-white/10 px-3 py-2 backdrop-blur-md transition-colors hover:bg-white/20">
            <p className="text-sm font-bold text-white">{c.nr}</p>
            <p className="text-[11px] font-semibold text-emerald-300">{brl(c.price_cents)}</p>
          </Link>
        ))}
      </div>
      <p className="mt-2 flex items-center gap-1.5 text-[11px] text-slate-300"><Award className="h-3.5 w-3.5 text-amber-400" /> Certificado válido, com prova e assinatura</p>
      <div className="mt-4 space-y-2">
        <Link to="/cursos" data-testid="login-courses-buy"
          className="flex h-11 w-full items-center justify-center gap-2 rounded-full bg-emerald-500 font-semibold text-white shadow-lg shadow-black/30 transition-transform hover:-translate-y-0.5">
          <ShoppingCart className="h-4 w-4" /> Ver catálogo e comprar
        </Link>
        <Link to="/escola" data-testid="login-courses-student"
          className="flex h-11 w-full items-center justify-center gap-2 rounded-full border border-white/30 bg-white/5 font-medium text-white transition-colors hover:bg-white/15">
          <LogIn className="h-4 w-4" /> Já sou aluno
        </Link>
      </div>
    </div>
  );
};
